import { render, staticRenderFns } from "./card2.vue?vue&type=template&id=cf1cae5a&scoped=true&"
import script from "./card2.vue?vue&type=script&lang=js&"
export * from "./card2.vue?vue&type=script&lang=js&"
import style0 from "./card2.vue?vue&type=style&index=0&id=cf1cae5a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1cae5a",
  null
  
)

export default component.exports